import { Injectable } from "@angular/core";
import { ContractsService } from "../contracts.service";
import { Web3Service } from "app/services/web3/web3.service";
import { Observable, first, from } from "rxjs";
import { contractAddress, eContracts } from "../contract.config";

@Injectable({
    providedIn: 'root'
})

export class MarketplaceService {

    public contract: any

    constructor(
        private contractsService: ContractsService,
        private web3Service: Web3Service
    ) {
        // this.contractsService.setContract(this.web3Service.getWeb3(), eContracts.MarketplaceProxy);
        // this.contractsService.getContractIstances(eContracts.MarketplaceProxy).pipe(first()).subscribe(c => this.contract = c);
        this.contract = this.contractsService.getContract(eContracts.MarketplaceProxy);
    }

    createOrder1155(ownerAddress: string, nftAddress: string, assetId: string, amount: number, priceInWei: string,
        paymentToken: string, expiresAt: string): Observable<any> {
        return from(this.contract.methods.createOrder1155(nftAddress, assetId, amount, priceInWei, paymentToken, expiresAt)
            .send({ ...this.contractsService.additionalParameters(), from: ownerAddress }));
    }

    cancelOrder1155(ownerAddress: string, nftAddress: string, assetId: string): Observable<any> {
        return from(this.contract.methods.cancelOrder1155(nftAddress, assetId)
            .send({ ...this.contractsService.additionalParameters(), from: ownerAddress }));
    }

    executeOrder1155(ownerAddress: string, assetId: string, seller: string, price: string, paymentToken: string): Observable<any> {
        let NFTItemAddress = contractAddress[this.web3Service.getNetworkName()].NFTItems;
        return from(this.contract.methods.executeOrder1155(NFTItemAddress, assetId, seller, price, paymentToken)
            .send({ ...this.contractsService.additionalParameters(), from: ownerAddress }));
    }

    createOrder(ownerAddress: string, tokenId: string, listingPrice: number, expirationDateUnix: number): Observable<any> {
        return from(this.contract.methods.createOrder(this.contractsService.getContractAddress(eContracts.KMONFTV2),
            tokenId, this.web3Service.toWei(listingPrice, 'ether'),
            '0xFFfFfFffFFfffFFfFFfFFFFFffFFFffffFfFFFfF', expirationDateUnix.toString()).send(
                {
                    ...this.contractsService.additionalParameters(),
                    from: ownerAddress
                })
        );
    }

    executeOrder(ownerAddress: string, contractAddress: string, tokenId: string, price: string, paymentToken: string): Observable<any> {
        return from(this.contract.methods.executeOrder(contractAddress, tokenId, price, paymentToken).send({
            ...this.contractsService.additionalParameters(),
            from: ownerAddress
        }));
    }

    cancelOrder(ownerAddress: string, tokenId: string): Observable<any> {
        return from(this.contract.methods.cancelOrder(this.contractsService.getContractAddress(eContracts.KMONFTV2), tokenId)
            .send({
                ...this.contractsService.additionalParameters(),
                from: ownerAddress
            }))
    }

}

@Injectable({
    providedIn: 'root'
})

export class MarketplaceBidService {

    public contract: any;
    diamondContract: any;

    constructor(
        private contractsService: ContractsService,
        private web3Service: Web3Service
    ) {
        // this.contractsService.setContract(this.web3Service.getWeb3(), eContracts.ERC721Bid);
        // this.contractsService.getContractIstances(eContracts.ERC721Bid).pipe(first()).subscribe(c => this.contract = c);
        this.contract = this.contractsService.getContract(eContracts.ERC721Bid);
        this.diamondContract = this.contractsService.getContract(eContracts.KMONFTV2)
    }

    placeBid(ownerAddress: string, tokenId: string, kmonBid: number, expirationDate: Date): Observable<any> {
        //TO CHECK if its possible to use parametric currency, at the moment the method accept only KMON
        let weiBid = this.web3Service.toWei(kmonBid);
        let KMONAddress = this.contractsService.getContractAddress(eContracts.KMON);
        let kmonNFTv2Address = this.contractsService.getContractAddress(eContracts.KMONFTV2);
        let expiryDelta: string = Math.round((expirationDate.getTime() - new Date().getTime()) / 1000).toString();
        return from(this.contract.methods.placeBid(kmonNFTv2Address, tokenId, weiBid, KMONAddress, expiryDelta).send({
            ...this.contractsService.additionalParameters(),
            from: ownerAddress
        }
        ));
    }

    //User placed
    cancelBid(ownerAddress: string, nftAddress: string, tokenId: string): Observable<any> {
        return from(this.contract.methods.cancelBid(nftAddress, tokenId).send({
            ...this.contractsService.additionalParameters(),
            from: ownerAddress
        }
        ));
    }

    acceptBid(ownerAddress: string, tokenId: string, blockchainId): Observable<any> {
        let ERC721BidAddress = this.contractsService.getContractAddress(eContracts.ERC721Bid);
        // let _blockchainId = this.web3Service.getWeb3().utils.hexToBytes(blockchainId);
        return from(this.diamondContract.methods.safeTransferFrom(ownerAddress, ERC721BidAddress, tokenId, blockchainId).send({
            ...this.contractsService.additionalParameters(),
            from: ownerAddress
        }
        ));
    }

    get _contract() {
        return this.contract;
    }

    // acceptToken
}